import { render, staticRenderFns } from "./Paginations.vue?vue&type=template&id=381f919e&scoped=true"
import script from "./Paginations.vue?vue&type=script&lang=js"
export * from "./Paginations.vue?vue&type=script&lang=js"
import style0 from "./Paginations.vue?vue&type=style&index=0&id=381f919e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381f919e",
  null
  
)

export default component.exports